import React from 'react';

const Project3 = () => {
    return (
        <div className='mx-10'>
        <div className='text-center mt-16'>
            <h1 className='text-3xl'>Project Details About <span className='text-orange-400 font-semibold'>Tutor Academy</span></h1>
        </div>
        <div className="grid gap-6 mt-8 mb-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          <div className="card card-compact h-full w-full bg-neutral shadow-xl">
            <figure>
              <img
                src="https://i.ibb.co/qFqkN1s/tutor1.png"
                className="w-full"
                alt="phone"
              />
            </figure>
            
          </div>
          <div className="card card-compact h-full w-full bg-neutral shadow-xl">
            <figure>
              <img
                src="https://i.ibb.co/VjQCKp3/tutor2.png"
                className="w-full"
                alt="fitness"
              />
            </figure>
            
          </div>
          <div className="card card-compact h-full w-full bg-neutral shadow-xl">
            <figure>
              <img
                src="https://i.ibb.co/1nsf3TX/tutor3.png"
                className="w-full"
                alt="tutor"
              />
            </figure>
            
          </div>
        </div>

        <div>
            <h1 className=' text-center text-3xl text-white font-semibold'>Description about Tutor Academy</h1>
            <div>
                <p className='text-xl'>Tutor Academy is a online based learning website. Where you can know about web technology.</p>
            </div>
            <div>
                <h3 className='text-2xl my-1 font-semibold'>Key Features Of Tutor Academy website:</h3>
                    <ul>
                        <li className='text-xl'>1. After come into the website you can understandent the basic feature of the website.</li>
                        <li className='text-xl'>2. Used dynamic route set in the header, when you click in the route you will reach dynamically.</li>
                        <li className='text-xl'>3. Clickable subject list. when you click the subject name then it redirect to you into course.</li>
                        <li className='text-xl'>4. user can read course details, and gain about the courses</li>
                        <li className='text-xl'>5. user can log into the website using google, email password, and github</li>
                        <li className='text-xl'>6. user cannot see the premium content of our website.</li>
                        <li className='text-xl'>7. to see the premium content user must login</li>
                    </ul>

                    <h3 className='text-2xl my-1 font-semibold'>Technology Used:</h3>
                    <p className='text-xl'>Bootstrap, react-bootstrap, react, react icons font awesome, react router dom, authentication, vercel cli, nodejs, expressjs</p>
            </div>
        </div>
                <div className='flex items-center justify-center mt-8 mb-10'>
                    <a href='https://tutor-academy-e5447.web.app/' className="btn btn-primary mr-3" target='_blank' rel="noreferrer">Live site</a>
                    <a href='https://github.com/Miraz9907/tutor-academy-client' className="btn btn-primary mr-3" target='_blank' rel="noreferrer">Github Client</a>
                    <a href='https://github.com/Miraz9907/tutor-academy-server' className="btn btn-primary mr-3" target='_blank' rel="noreferrer">Github Server</a>
                </div>
      </div>
    );
};

export default Project3;